import React, { useState, useEffect } from 'react'
import Modal from './Modal';
import { Link } from 'react-router-dom';

function GalleryThree() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState('');
    const [galleryImages, setGalleryImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fetch gallery data from API
    useEffect(() => {
        const fetchGalleryData = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://dzsoftech.net/tours/api/airticket/gallery/');
                if (!response.ok) {
                    throw new Error('Failed to fetch gallery data');
                }
                const data = await response.json();
                
                if (data.results && data.results.length > 0) {
                    // Get active images, prioritize featured ones
                    const activeImages = data.results
                        .filter(img => img.is_active)
                        .sort((a, b) => {
                            if (a.featured && !b.featured) return -1;
                            if (!a.featured && b.featured) return 1;
                            return a.order - b.order;
                        });
                    setGalleryImages(activeImages);
                } else {
                    // Use fallback images if no data
                    setGalleryImages(getFallbackImages());
                }
            } catch (err) {
                console.error('Error fetching gallery data:', err);
                setError(err.message);
                // Use fallback images on error
                setGalleryImages(getFallbackImages());
            } finally {
                setLoading(false);
            }
        };

        fetchGalleryData();
    }, []);

    // Fallback images if API fails or returns no data
    const getFallbackImages = () => {
        return [
            {
                id: 'fallback-1',
                title: 'Gallery Image 1',
                image_url: '/assets/img/gallery/gallery_3_1.jpg',
                featured: true,
                order: 1
            },
            {
                id: 'fallback-2',
                title: 'Gallery Image 2', 
                image_url: '/assets/img/gallery/gallery_3_2.jpg',
                featured: true,
                order: 2
            },
            {
                id: 'fallback-3',
                title: 'Gallery Image 3',
                image_url: '/assets/img/gallery/gallery_3_3.jpg',
                featured: true,
                order: 3
            },
            {
                id: 'fallback-4',
                title: 'Gallery Image 4',
                image_url: '/assets/img/gallery/gallery_3_4.jpg',
                featured: false,
                order: 4
            },
            {
                id: 'fallback-5',
                title: 'Gallery Image 5',
                image_url: '/assets/img/gallery/gallery_3_5.jpg',
                featured: true,
                order: 5
            },
            {
                id: 'fallback-6',
                title: 'Gallery Image 6',
                image_url: '/assets/img/gallery/gallery_3_6.jpg',
                featured: true,
                order: 6
            }
        ];
    };

    // Function to open the modal with the selected image
    const openModal = (imageSrc, event) => {
        event.preventDefault(); // Prevent default link behavior
        setModalImage(imageSrc);
        setIsModalOpen(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setIsModalOpen(false);
    };
    
    // Function to get image URL with fallback
    const getImageUrl = (image, fallbackPath) => {
        return image.image_url || image.image || fallbackPath;
    };
    
    // Ensure we have at least 6 images for the layout
    const displayImages = galleryImages.length >= 6 ? galleryImages.slice(0, 6) : [...galleryImages, ...getFallbackImages()].slice(0, 6);
    return (
        <div className="overflow-hidden space-bottom">
            <div className="container">
                <div className="title-area text-center">
                    <span className="sub-title">Make Your Tour More Pleasure</span>
                    <h2 className="sec-title">Recent Gallery</h2>
                </div>
                {loading ? (
                    <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="row gy-24 gx-24 justify-content-center">
                        {/* First column - single image */}
                        {displayImages[0] && (
                            <div className="col-lg-3">
                                <div className="gallery-box style2">
                                    <div className="gallery-img global-img">
                                        <Link
                                            to={getImageUrl(displayImages[0], '/assets/img/gallery/gallery_3_1.jpg')}
                                            className="popup-image"
                                            onClick={(e) => openModal(getImageUrl(displayImages[0], '/assets/img/gallery/gallery_3_1.jpg'), e)}
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src={getImageUrl(displayImages[0], '/assets/img/gallery/gallery_3_1.jpg')}
                                                alt={displayImages[0].title || 'Gallery Image'}
                                            />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                        
                        {/* Second column - two stacked images */}
                        <div className="col-lg-3">
                            {displayImages[1] && (
                                <div className="gallery-box style2">
                                    <div className="gallery-img global-img">
                                        <Link
                                            to={getImageUrl(displayImages[1], '/assets/img/gallery/gallery_3_2.jpg')}
                                            className="popup-image"
                                            onClick={(e) => openModal(getImageUrl(displayImages[1], '/assets/img/gallery/gallery_3_2.jpg'), e)}
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src={getImageUrl(displayImages[1], '/assets/img/gallery/gallery_3_2.jpg')}
                                                alt={displayImages[1].title || 'Gallery Image'}
                                            />
                                        </Link>
                                    </div>
                                </div>
                            )}
                            {displayImages[3] && (
                                <div className="gallery-box style2">
                                    <div className="gallery-img global-img">
                                        <Link
                                            to={getImageUrl(displayImages[3], '/assets/img/gallery/gallery_3_4.jpg')}
                                            className="popup-image"
                                            onClick={(e) => openModal(getImageUrl(displayImages[3], '/assets/img/gallery/gallery_3_4.jpg'), e)}
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src={getImageUrl(displayImages[3], '/assets/img/gallery/gallery_3_4.jpg')}
                                                alt={displayImages[3].title || 'Gallery Image'}
                                            />
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                        
                        {/* Third column - large image and two smaller ones */}
                        <div className="col-lg-6">
                            {displayImages[2] && (
                                <div className="gallery-box style2">
                                    <div className="gallery-img global-img">
                                        <Link
                                            to={getImageUrl(displayImages[2], '/assets/img/gallery/gallery_3_3.jpg')}
                                            className="popup-image"
                                            onClick={(e) => openModal(getImageUrl(displayImages[2], '/assets/img/gallery/gallery_3_3.jpg'), e)}
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src={getImageUrl(displayImages[2], '/assets/img/gallery/gallery_3_3.jpg')}
                                                alt={displayImages[2].title || 'Gallery Image'}
                                            />
                                        </Link>
                                    </div>
                                </div>
                            )}
                            <div className="gallery-box-wrapp">
                                {displayImages[4] && (
                                    <div className="gallery-box style2">
                                        <div className="gallery-img global-img">
                                            <Link
                                                to={getImageUrl(displayImages[4], '/assets/img/gallery/gallery_3_5.jpg')}
                                                className="popup-image"
                                                onClick={(e) => openModal(getImageUrl(displayImages[4], '/assets/img/gallery/gallery_3_5.jpg'), e)}
                                            >
                                                <div className="icon-btn">
                                                    <i className="fal fa-magnifying-glass-plus" />
                                                </div>
                                                <img
                                                    src={getImageUrl(displayImages[4], '/assets/img/gallery/gallery_3_5.jpg')}
                                                    alt={displayImages[4].title || 'Gallery Image'}
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                )}
                                {displayImages[5] && (
                                    <div className="gallery-box style2">
                                        <div className="gallery-img global-img">
                                            <Link
                                                to={getImageUrl(displayImages[5], '/assets/img/gallery/gallery_3_6.jpg')}
                                                className="popup-image"
                                                onClick={(e) => openModal(getImageUrl(displayImages[5], '/assets/img/gallery/gallery_3_6.jpg'), e)}
                                            >
                                                <div className="icon-btn">
                                                    <i className="fal fa-magnifying-glass-plus" />
                                                </div>
                                                <img
                                                    src={getImageUrl(displayImages[5], '/assets/img/gallery/gallery_3_6.jpg')}
                                                    alt={displayImages[5].title || 'Gallery Image'}
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Modal isOpen={isModalOpen} closeModal={closeModal} imageSrc={modalImage} />
        </div>

    )
}

export default GalleryThree
